<div id="ticketMobileOverlay" class="overlay over blur" (click)="closeDialog()"></div>
<section id="ticketWrap" class="ticket-mobile-wrap dialogV2" [class.expand]="showTicketDialogV2"
  (click)="$event.stopPropagation();">
  <!-- <div class="close-wrap" [class.played]="dialogModel.ticketType === ticketPlayTypeEnum.PlayedTicket">
    <div class="close" (click)="closeDialog()">
      <i class="icon icon-cross"></i>
    </div>
  </div> -->
  <div class="border">
    <section class="ticket-wrap" [class.show]="showTicketDialogV2">

      <div class="ticket-detail-header">
        <div class="ticket-info" *ngIf="dialogModel.createdOnDate">{{dialogModel.createdOnDate}}</div>
        <div class="title {{ticketStatusEnum[dialogModel.confirmationOrPlayedTicket?.statusId] | lowercase}}">
          <ng-container *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlayedTicket">
            {{dynamicTranslations['ticketAndOtherStatuses_'+[ticketStatusEnum[dialogModel.confirmationOrPlayedTicket?.statusId]]]
            ? dynamicTranslations['ticketAndOtherStatuses_' +
            [ticketStatusEnum[dialogModel.confirmationOrPlayedTicket?.statusId]]] :
            dialogModel.confirmationOrPlayedTicket?.ticketStatus }}
          </ng-container>
          <div class="header-title" *ngIf="dialogModel.ticketType !== ticketPlayTypeEnum.PlayedTicket" i18n="ConfirmTicket Title@@ConfirmTicketTitle"> POTVRDA LISTIĆA</div>
          <div class="changes-text"
            *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.ConfirmationTicket || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket"
            i18n="ConfirmTicketChanges Title@@ConfirmTicketChangesTitle"> DOŠLO JE DO PROMENE NA VAŠEM TIKETU
          </div>
        </div>
        <div class="ticket-id" *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlayedTicket">
          {{dialogModel.confirmationOrPlayedTicket?.ticketId}}
        </div>
      </div>

      <div class="ticket-content-wrap" [class.show]="showTicketDialogV2">
        <section class="ticket-body" *ngIf="orderingForTicketItemGroups.length > 0">
          <article class="ticket-item" *ngFor="let orderingGroup of orderingForTicketItemGroups">
            <ng-container *ngIf="dialogModel.ticketItemEventGroups[orderingGroup.eventId]; let ticketItemGroup">
              <ng-container *ngIf="ticketItemGroup.liveScore || ticketItemGroup.scores?.length !== 0">
                <div class="result-expand" *ngIf="!ticketItemGroup.liveScore; else liveResult">
                  <div class="row">
                    <div class="bet-type-col" >
                      <div class="outcome-wrap" *ngFor="let score of ticketItemGroup.scores">{{score.scoreGroupName}}</div>
                    </div>
                    <div class="expand-event"></div>
                  </div>

                  <div class="row">
                    <div class="bet-type-wrap">
                      <div class="bet-type-col">
                        <div class="outcome-wrap" *ngFor="let score of ticketItemGroup.scores">
                          <span class="result-box" *ngFor="let scorePeriod of score.scorePeriods">
                            <ng-container *ngIf="score.hasHomeAway; else singleScore">
                              <span>{{scorePeriod.homeAwayValue[enumsHomeAway.HOME]}}</span>
                              <span>{{scorePeriod.homeAwayValue[enumsHomeAway.AWAY]}}</span>
                            </ng-container>
                            <ng-template #singleScore>
                                <span>{{scorePeriod.homeAwayValue[enumsHomeAway.NONE]}}</span>
                            </ng-template>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="expand-event bcg" (click)="expandEvent(ticketItemGroup)" >+</div>
                  </div>
                </div>
                <ng-template #liveResult>
                  <div class="result-expand">
                    <div class="row">
                      <div class="bet-type-col" >
                        <div class="outcome-wrap" i18n="My ticket details result@@myTicketsResultsFulltime">Fulltime</div>
                        <div class="outcome-wrap" i18n="My ticket details result@@myTicketsResultsPeriod">Period</div>
                      </div>
                      <!-- <div class="expand-event"></div> -->
                    </div>

                    <div class="row">
                      <div class="bet-type-wrap">
                        <div class="bet-type-col">
                          <div class="outcome-wrap">
                            <span class="result-box">
                              <span>{{ticketItemGroup.liveScore.homeScore}}</span>
                              <span>{{ticketItemGroup.liveScore.awayScore}}</span>
                            </span>
                          </div>

                          <div class="outcome-wrap">
                            <span class="result-box">
                              <div class="flex">
                                <span *ngFor="let period of ticketItemGroup.liveScore.homeSetScore">{{period}}</span>
                              </div>
                              <div class="flex">
                                <span *ngFor="let period of ticketItemGroup.liveScore.awaySetScore">{{period}}</span>
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-container>

              <div class="event-info">
                <div class="team-name-wrap">
                  <div class="team-name">
                    <i class="icon-ex-sm s-icon-{{getSportName(ticketItemGroup.sportId)}} sportid-{{ticketItemGroup.sportId}}"></i>
                    <span class="name" *ngIf="ticketItemGroup.eventHomeTeam || ticketItemGroup.eventAwayTeam; else eventName">
                      {{ticketItemGroup.eventHomeTeam}}
                      <span *ngIf="ticketItemGroup.eventAwayTeam;">-</span>
                      {{ticketItemGroup.eventAwayTeam}}</span>
                    <ng-template #eventName>
                      <span class="name">{{ticketItemGroup.eventName}}</span>
                    </ng-template>
                    <span class="live-event" *ngIf="ticketItemGroup.isLive">LIVE</span>
                    <span class="live-event"
                      *ngIf="ticketItemGroup.mappingType == eventMappingTypeEnum.SuperBetEvent">{{dynamicTranslations.specialOfferEventsShorcutSuperBet}}</span>
                    <span class="live-event"
                      *ngIf="ticketItemGroup.mappingType == eventMappingTypeEnum.EventOfDay">{{dynamicTranslations.specialOfferEventsShorcutEventOfDay}}</span>
                  </div>
                  <!-- <div class="date-time">
                    <ng-container *ngIf="ticketItemGroup.homeScore !== '-'; else date">
                      <span class="date">{{ticketItemGroup.homeScore}} : {{ticketItemGroup.awayScore}}</span>
                    </ng-container>
                    <ng-template #date>
                      <span class="date" *ngIf="today.getDate() != ticketItemGroup.eventDateTime.getDate()">{{ticketItemGroup.eventDate}}</span>
                      <span class="time"> {{ticketItemGroup.eventTime}}</span>
                    </ng-template>
                  </div> -->
                  <span class="date-time result" *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlayedTicket && (ticketItemGroup.liveScore || ticketItemGroup.scores?.length !== 0); else date" (click)="showResult($event)">
                    <ng-container *ngIf="ticketItemGroup.liveScore; else prematchResult">
                      {{ticketItemGroup.liveScore.homeScore}} : {{ticketItemGroup.liveScore.awayScore}}
                    </ng-container>

                    <ng-template #prematchResult>
                      <ng-container *ngFor="let score of ticketItemGroup.scores">
                        <ng-container *ngIf="score.scoreGroupId === 2">
                          {{score.scorePeriods[0].homeAwayValue[1]}} : {{score.scorePeriods[0].homeAwayValue[2]}}
                        </ng-container>
                      </ng-container>
                    </ng-template>


                    <i class="result-description icon icon-ex-sm s-icon-sporticon-error"></i>
                  </span>
                  <ng-template #date>
                    <span class="date-time">{{ticketItemGroup.dateTimeShort}}</span>
                  </ng-template>





                </div>
              </div>
              <div class="outcome-main-wrap">
                <ng-container *ngFor="let outcomeId of orderingGroup.outcomeIds">
                  <div class="outcome-wrap" *ngIf="ticketItemGroup.ticketItems[outcomeId]; let ticketItem"
                    [class.height]="ticketItem.oldOdd != ticketItem.odd">
                    <div class="outcome-content-wrap">
                      <div class="banker" [class.active]="ticketItemGroup.isInBankersGroup">
                        <!-- <input type="checkbox" [(ngModel)]="ticketItemGroup.isInBankersGroup"
                          [attr.id]="ticketItemGroup.eventId" /> -->
                        <label class="square" [attr.for]="ticketItemGroup.eventId"> FIX </label>
                      </div>
                      <div class="outcome-name-wrap">
                        <div class="bet-type-name">
                          {{ticketItem.betName}}
                          <ng-container *ngIf="ticketItem.sbv">
                            -
                            <span class="sbv">
                              <ng-container *ngIf="!ticketItem.useSbvHandicapPipe">{{ticketItem.sbv}}</ng-container>
                              <ng-container *ngIf="ticketItem.useSbvHandicapPipe">{{ticketItem.sbv | handicapSbv}}</ng-container>
                            </span>
                          </ng-container>
                        </div>
                        <div class="outcome-name">{{ticketItem.betOutcomeName}}</div>
                      </div>
                      <div class="outcome {{betOutcomeResultEnum[ticketItem?.status] | lowercase}}-outcome">
                        <ng-container
                          *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlayedTicket || (ticketItem.isBetOutcomePlayable && ticketItem.isBetPlayable && ticketItemGroup.isEventPlayable && ticketItem.odd > 1 ); else lockedOdd">
                          <span class="old-odd" *ngIf="ticketItem.oldOdd != ticketItem.odd"
                            [ngClass]="{'old-higher': ticketItem.oldOdd > ticketItem.odd, 'old-lower': ticketItem.oldOdd < ticketItem.odd}">{{ticketItem.oldOdd
                            | odd}}</span>
                          <span class="odd">{{ticketItem.odd | odd}}</span>
                        </ng-container>
                        <ng-template #lockedOdd>
                          <div class="icon-wrap">
                            <app-svg-icon iconId="lock"></app-svg-icon>
                          </div>
                        </ng-template>
                      </div>
                    </div>

                  </div>
                </ng-container>
                <div class="line"></div>

              </div>
            </ng-container>

          </article>
        </section>

      <div class="ticket-info-box" *ngIf="dialogModel.ticketData.numberOfBets > 1">
        <div>
            <span i18n="Number of combinations ticket calculator@@NumberOfCombinatuionsMob">Ukupno kombinacija</span>
            <span>{{dialogModel.ticketData.numberOfBets}}</span>
        </div>

        <div>
            <span i18n="Stake per combination ticket calculator@@StakePerCombinationMob">Ulog po kombinaciji</span>
            <span>{{dialogModel.ticketData.wagerPerBet | number: displayFormat}} {{CV.CURRENCY}}</span>
        </div>
      </div>

        <ng-container>
          <div class="choose-system">
          <div class="system-option">
            <div class="title" (click)="this.showSystemOptions = !this.showSystemOptions; $event.stopPropagation(); ">
              <span i18n="System review@@SystemReview">Pregled sistema</span>
              <i class="arrow-down icon icon-chevron-up" [class.closed]="!showSystemOptions"></i>
          </div>
          <ng-container *ngIf="this.showSystemOptions">
            <span *ngIf="selectedSystemOptions; else noSystemOption">
              <ng-container *ngFor="let systemOption of selectedSystemOptions; let i = index">
                <ng-container *ngIf="systemOption.optionSelected">
                  <ng-container *ngIf="i>0">,</ng-container>{{systemOption.eventsInCombination}}
                </ng-container>
              </ng-container>
              <ng-container>/{{selectedSystemOptions[0]?.totalNumberOfEvents}}</ng-container>
            </span>
            <ng-template #noSystemOption>
              <span *ngIf="dialogModel.confirmationOrPlayedTicket">
                {{dialogModel.confirmationOrPlayedTicket.systemName}}
              </span>
            </ng-template>
            <span class="bold" *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlayedTicket && !dialogModel.isFix"> {{dialogModel.confirmationOrPlayedTicket.ticketTypeName}}</span>
            <ng-container *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlayedTicket && dialogModel.ticketData.numberOfBets > 1 && dialogModel.isFix">
              <span i18n="System review@@SystemReview">Pregled sistema</span>
              <span class="bold">Fix</span>
            </ng-container>
          </ng-container>
          </div>
        </div>

          <!-- <div class="ticket-info-row border highlight">
            <span *ngIf="dialogModel.ticketType != ticketPlayTypeEnum.ConfirmationTicket; else confirmationTotal">
              <span i18n="Total Odd ticket calculator@@TotalOdd">Tečaj</span>:
              <span class="color"> {{dialogModel.ticketData.totalOdd | number:'1.2-2'}}</span>
            </span>
            <ng-template #confirmationTotal>
              <div class="adjusted-odd-wrap">
                <div class="changed" *ngIf="dialogModel.ticketData.totalOdd != dialogModel.requestedTotalOdd">
                  <ng-container i18n="Adjusted Odd ticket calculator@@AdjustedOdd">Korigovana kvota</ng-container>:
                  {{dialogModel.ticketData.totalOdd | number:'1.2-2'}}
                </div>
                <span>
                  <ng-container i18n="Requested Odd ticket calculator@@RequestedOdd">Zahtevana kvota</ng-container>:
                  {{dialogModel.requestedTotalOdd | number:'1.2-2'}}
                </span>
              </div>
            </ng-template>

            <span *ngIf="dialogModel.ticketType == ticketPlayTypeEnum.PlayedTicket">
              <span i18n="Possible paout ticket calculator@@PossiblePayout">Ev. isplata</span>:
              <span>{{dialogModel.ticketData.possiblePayout | number: displayFormat}} {{CV.CURRENCY}}</span>
            </span>

            <span *ngIf="dialogModel.ticketType != ticketPlayTypeEnum.PlayedTicket">
              <span i18n="Possible paout ticket calculator@@PossiblePayout">Ev. Isplata</span>:
              <span class="bold color"> {{dialogModel.ticketData.possibleWinWithoutTax | number: displayFormat}}
                {{CV.CURRENCY}}</span>
            </span>
          </div> -->

          <div class="ticket-info-row" *ngIf="dialogModel.ticketData.bonus > 0">
            <span>
              <ng-container i18n="Bonus ticket calculator@@Bonus">Bonus</ng-container>:
              ({{dialogModel.ticketData.bonusPercent |  number:displayFormat}}%)
            </span>
            <span>{{dialogModel.ticketData.bonus | number: displayFormat}} {{CV.CURRENCY}}</span>
          </div>

          <ng-container
            *ngIf="dialogModel.requestedStake == dialogModel.ticketData.totalStake || dialogModel.ticketType != ticketPlayTypeEnum.ConfirmationTicket; else confirmationStake">
            <div class="ticket-info-row">
              <span>
                <span i18n="Ticket Pay in text@@TicketPayIn">Uplata</span>:
              </span>
              <span> {{dialogModel.ticketData.payin | number:'1.2-2'}} {{currency}}</span>
            </div>
            <div class="ticket-info-row">
              <!-- <span i18n="Total stake on ticket@@TotalStakeWithoutTax">Ulog <span *ngIf="taxBeforeStakeDefinitionPercent">(-{{taxBeforeStakeDefinitionPercent}}% mt)</span></span> -->
              <span>
                <span i18n="Total stake on ticket@@TotalStakeWithoutTax">Ulog</span>
                <span *ngIf="taxBeforeStakeDefinitionPercent">(-{{taxBeforeStakeDefinitionPercent}}% mt)</span>:
              </span>
              <span>{{dialogModel.ticketData.totalStake | number: displayFormat}} {{CV.CURRENCY}}</span>
            </div>
          </ng-container>

          <ng-template #confirmationStake>
            <div class="ticket-info-row">
              <span><span i18n="Requested Stake ticket calculator@@RequestedStake">Zahtevana uplata</span>:</span>
              <span> {{dialogModel.requestedPayIn | number:'1.2-2'}} {{currency}}</span>
            </div>
            <div class="ticket-info-row changed">
              <span><span i18n="Adjusted Stake ticket calculator@@AdjustedStake">Korigovana uplata</span>:</span>
              <span>{{dialogModel.ticketData.payin | number:'1.2-2'}} {{currency}}</span>
            </div>
          </ng-template>

          <!-- <div class="ticket-info-row" *ngIf=" dialogModel.ticketData.totalStake != dialogModel.ticketData.payin">
            <span><span>Porez na uplatu</span>:</span> <span> {{dialogModel.ticketData.taxBeforeStake | number:'1.2-2'}}
              {{currency}}</span>
          </div> -->

          <div class="ticket-info-row">
            <span><span i18n="Win ticket calculator@@Win">Dobitak</span>:</span>
            <span>{{dialogModel.ticketData.possibleWin | number: displayFormat}} {{CV.CURRENCY}}</span>
          </div>
          <div class="ticket-info-row" *ngIf="dialogModel.ticketData.taxOnWinings">
            <span><span i18n="Tax on winnings@@TaxOnWinings">Porez</span>:</span>
            <span>{{dialogModel.ticketData.taxOnWinings | number: displayFormat}} {{CV.CURRENCY}}</span>
          </div>
          <ng-container *ngIf="dialogModel.ticketData.numberOfBets > 1">
            <!-- <div class="ticket-info-row" *ngIf="dialogModel.ticketType == ticketPlayTypeEnum.PlaceBet">
              <span><span i18n="Min possible payout shorted@@MinPossiblePayoutShorted">Min isplata</span>:</span>
              <span>{{dialogModel.ticketData.possibleMinPayout | number: displayFormat}} {{CV.CURRENCY}}</span>
            </div>
            <div class="ticket-info-row" *ngIf="dialogModel.ticketType != ticketPlayTypeEnum.PlayedTicket">
              <span><span i18n="Max possible payout shorted@@MaxPossiblePayoutShorted">Max isplata</span>:</span>
              <span>{{dialogModel.ticketData.possibleWinWithoutTax | number: displayFormat}} {{CV.CURRENCY}}</span>
            </div> -->

            <!-- <div class="ticket-info-row" *ngIf="dialogModel.ticketType == ticketPlayTypeEnum.PlayedTicket">
              <span><span i18n="Max possible payout shorted@@MaxPossiblePayoutShorted">Max isplata</span>:</span>
              <span>{{dialogModel.ticketData.possiblePayout | number: displayFormat}} {{CV.CURRENCY}}</span>
            </div> -->

            <div class="ticket-info-row" *ngIf="dialogModel.ticketData.freeBetValue > 0" >
              <span><span i18n="Possible win ticket calculator@@freeBetValue">Potencijalni freebet dobitak</span>:</span>
              <span>{{dialogModel.ticketData.freeBetValueToShow | number: displayFormat}} {{CV.CURRENCY}}</span>
            </div>

            <div class="ticket-info-row"
              *ngIf="dialogModel.ticketType == ticketPlayTypeEnum.PlayedTicket && dialogModel.ticketData.totalStake && dialogModel.ticketData.taxOnMinWinning">
              <span><span>Porez na minimalnu isplatu</span>:</span> <span> {{dialogModel.ticketData.taxOnMinWinning |
                number:'1.2-2'}}
                {{currency}}</span>
            </div>
          </ng-container>
        </ng-container>
        <div class="ticket-info-row highlight" (click)="dialogModel.ticketData.numberOfBets> 1? showPayoutInfos = !showPayoutInfos : showPayoutInfos = showPayoutInfos">
          <span *ngIf="dialogModel.ticketType != ticketPlayTypeEnum.ConfirmationTicket; else confirmationTotal">
            <span i18n="Total Odd ticket calculator@@TotalOdd">Tečaj</span>:
            <span class="color"> {{dialogModel.ticketData.totalOdd | number:'1.2-2'}}</span>
          </span>
          <ng-template #confirmationTotal>
            <div class="adjusted-odd-wrap">
              <span>
                <ng-container i18n="Requested Odd ticket calculator@@RequestedOdd">Zahtevana kvota</ng-container>:
                {{dialogModel.requestedTotalOdd | number:'1.2-2'}}
              </span>
              <div class="changed" *ngIf="dialogModel.ticketData.totalOdd != dialogModel.requestedTotalOdd">
                <ng-container i18n="Adjusted Odd ticket calculator@@AdjustedOdd">Korigovana kvota</ng-container>:
                {{dialogModel.ticketData.totalOdd | number:'1.2-2'}}
              </div>
            </div>
          </ng-template>
          <div class="flex">
            <div class="right-content" *ngIf="dialogModel.ticketType == ticketPlayTypeEnum.PlayedTicket">
              <span i18n="Possible paout ticket calculator@@PossiblePayout">Ev. isplata</span>:
              <span>{{dialogModel.ticketData.possiblePayout | number: displayFormat}} {{CV.CURRENCY}}</span>
            </div>

            <div class="right-content" *ngIf="dialogModel.ticketType != ticketPlayTypeEnum.PlayedTicket">
              <span i18n="Possible paout ticket calculator@@PossiblePayout">Ev. Isplata</span>:
              <span class="bold color"> {{dialogModel.ticketData.possibleWinWithoutTax | number: displayFormat}}
                {{CV.CURRENCY}}</span>
            </div>
            <div>
              <!-- <i class="arrow-down icon icon-chevron-down" [class.closed]="!showPayoutInfos"></i> -->
              <i *ngIf="dialogModel.ticketData.numberOfBets > 1" class="arrow-down icon" [ngClass]="{'icon-chevron-up': showPayoutInfos, 'icon-chevron-down': !showPayoutInfos }"></i>
            </div>
          </div>

        </div>
        <ng-container *ngIf="showPayoutInfos">
          <div class="ticket-info-row" *ngIf="dialogModel.ticketData.possibleWinWithoutTax!=dialogModel.ticketData.possibleMinPayout">
            <span><span i18n="Min possible payout shorted@@MinPossiblePayoutShorted">Min isplata</span>:</span>
            <span>{{dialogModel.ticketData.possibleMinPayout | number: displayFormat}} {{CV.CURRENCY}}</span>
          </div>
          <div class="ticket-info-row" *ngIf="dialogModel.ticketData.totalWinings > 0">
            <span><span i18n="Max possible payout shorted@@MaxPossiblePayoutShorted">Max isplata</span>:</span>
            <span>{{dialogModel.ticketData.possibleWinWithoutTax | number: displayFormat}} {{CV.CURRENCY}}</span>
          </div>
          <app-winnings-per-hit *ngIf="dialogModel.ticketType == ticketPlayTypeEnum.PlayedTicket && dialogModel.ticketData.possibleWinForNumberOfHits?.length > 1" [possibleWinForNumberOfHits]="dialogModel.ticketData.possibleWinForNumberOfHits"> </app-winnings-per-hit>
        </ng-container>

        <div class="radio-wrap" *ngIf="dialogModel.ticketType == ticketPlayTypeEnum.PlaceBet ">

          <div class="custom-radio mobileV2"
            *ngIf="(dialogModel.ticketType === ticketPlayTypeEnum.PlaceBet || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket)  && ((isUserLoggedIn && accountBalance >= dialogModel.ticketData.totalStake) || (tmUser && tmUser.isC))">
            <input type="radio" id="typeOfplaceBet1" name="typeOfplaceBet" [value]="placeBetTypeEnum.Standard"
              [(ngModel)]="dialogModel.typeOfPlaceBetTicket">
            <label for="typeOfplaceBet1" i18n="Pay in from web@@PayInFromWeb">uplati s web računa</label>
          </div>

          <div class="custom-radio mobileV2"
            *ngIf="(dialogModel.ticketType === ticketPlayTypeEnum.PlaceBet || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket) && !tmUser"
            [class.offline]="maxTotalOdd < this.dialogModel.ticketData.totalOdd">
            <input type="radio" id="typeOfplaceBet2" name="typeOfplaceBet" [value]="placeBetTypeEnum.Express"
              [attr.checked]="true" [(ngModel)]="dialogModel.typeOfPlaceBetTicket">
            <label for="typeOfplaceBet2" i18n="Pay in at shop@@PayInAtShop">uplati u poslovnici</label>
          </div>

          <div
            *ngIf="(dialogModel.ticketType === ticketPlayTypeEnum.PlaceBet || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket) && isUserLoggedIn && dialogModel.ticketData.freeBetValue > 0 && freeBetBalance >= dialogModel.ticketData.totalStake"
            class="custom-radio mobileV2">
            <input type="radio" id="typeOfplaceBet3" name="typeOfplaceBet" [value]="placeBetTypeEnum.FreeBet"
              [(ngModel)]="dialogModel.typeOfPlaceBetTicket">
            <label for="typeOfplaceBet3"
              i18n="ticket Confirm FreeBet Ticket button@@ConfirmTicketFreeBetTicket">FreeBet</label>
          </div>


        </div>

        <ng-container
          *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlaceBet || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket">
          <div class="line"></div>

          <div class="odd-change-wrap">
            <span><span i18n="ODD CHANGES SPAN@@oddChanges">PROMENA KVOTA</span>:</span>
            <div class="radio-wrap">
              <div class="custom-radio mobileV2">
                <input type="radio" id="acceptAllTicketDialog" name="acceptOddTicketDialog"
                  [value]="oddsValidationModeEnum.AcceptAllOdds" [(ngModel)]="dialogModel.validationMode"
                  [attr.checked]="dialogModel.validationMode == oddsValidationModeEnum.AcceptAllOdds">
                <label for="acceptAllTicketDialog"
                  (click)="changeOddsValidationMode(oddsValidationModeEnum.AcceptAllOdds)"
                  i18n="Accept all changes radio@@AcceptAll">Prihvati sve</label>
              </div>
              <div class="custom-radio mobileV2">
                <input type="radio" id="acceptHigherTicketDialog" name="acceptOddTicketDialog"
                  [value]="oddsValidationModeEnum.AcceptHigherOdds" [(ngModel)]="dialogModel.validationMode"
                  [attr.checked]="dialogModel.validationMode == oddsValidationModeEnum.AcceptHigherOdds">
                <label for="acceptHigherTicketDialog"
                  (click)="changeOddsValidationMode(oddsValidationModeEnum.AcceptHigherOdds)"
                  i18n="Accept higher changes radio@@AcceptHigher">Prihvati veću</label>
              </div>
              <!-- // commneted because notifications are not redy for deploy
                  <div *ngIf="isUserLoggedInForNot" class="custom-radio">
                      <input type="checkbox" id="notificationTicketDialog" name="notificationTicketDialog"  (change)="receiveNotification=!receiveNotification" [checked]="receiveNotification">
                      <label for="notificationTicketDialog">Notifikacije</label>
                  </div>  -->
            </div>
          </div>
        </ng-container>
        <div class="invalid-place-bet alert primary"
          *ngIf="(!isUserLoggedIn ||
          (dialogModel.ticketData.totalStake > accountBalance && dialogModel.typeOfPlaceBetTicket === placeBetTypeEnum.Standard)
          || (freeBetBalance < dialogModel.ticketData.totalStake  && dialogModel.typeOfPlaceBetTicket === placeBetTypeEnum.FreeBet)) && dialogModel.ticketType != ticketPlayTypeEnum.PlayedTicket">
          <span *ngIf="!isUserLoggedIn" i18n="ticket Confirm not logged in@@ConfirmTicketNotLoggedIn">za uplatu
            tiketa,
            morate biti ulogovani</span>
          <span *ngIf="isUserLoggedIn
           && (dialogModel.ticketData.totalStake > accountBalance && dialogModel.typeOfPlaceBetTicket === placeBetTypeEnum.Standard)
           || (freeBetBalance < dialogModel.ticketData.totalStake  && dialogModel.typeOfPlaceBetTicket === placeBetTypeEnum.FreeBet)"><span
              i18n="ticket Confirm not enough funds@@ConfirmTicketNotEnoughFunds">nedovoljno sredstava na racunu, za
              uplatu tiketa</span> - {{accountBalance | number:'1.2-2'}} {{currency}}</span>
        </div>
      </div>





    </section>
    <div class="ticket-dialog-buttons">
      <ng-container *ngIf="dialogModel.ticketType !== ticketPlayTypeEnum.PlayedTicket">
        <ng-container
          *ngIf="!dialogModel.ticketData.isTicketOnline || maxTotalOdd < this.dialogModel.ticketData.totalOdd; else ticketIsOnline">
          <div class="alert danger" *ngIf="!dialogModel.ticketData.isTicketOnline">
            <ng-container i18n="Offline Events In Ticket ticket calculator button@@OfflineEventsInTicket">OFFLINE
              događaji na tiketu</ng-container>
          </div>
          <div class="alert danger" *ngIf="dialogModel.ticketData.isTicketOnline">{{errorMsg}} {{maxTotalOdd |
            number:'1.2-2'}}</div>
        </ng-container>
        <ng-template #ticketIsOnline>
          <div class="buttons-wrap">
            <!-- <button id="btnFreeBet"  [class.offline]="maxTotalOdd < dialogModel.ticketData.totalOdd" *ngIf="(dialogModel.ticketType === ticketPlayTypeEnum.PlaceBet || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket) && isUserLoggedIn && dialogModel.ticketData.freeBetValue > 0 && freeBetBalance >= dialogModel.ticketData.totalStake" (click)="freeBetTicket()" >FREEBET</button> -->
            <div class="button place-bet cancel" id="btnCancelTicket"
              *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlaceBet || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket"
              (click)="openTicketDetails()" (click)="closeDialog()">
              <ng-container i18n="ticket COnfirmation Ticket button@@CancelTicket">ODUSTANI</ng-container>
            </div>
            <div class="button place-bet cancel" id="btnCancelTicket"
              *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.ConfirmationTicket" (click)="openTicketDetails()" (click)="cancelTicket()">
              <ng-container i18n="ticket COnfirmation Ticket button@@CancelTicket">ODUSTANI</ng-container>
            </div>
            <div class="button place-bet" id="btnConfirmTicketConfirm"
              *ngIf="(dialogModel.ticketType === ticketPlayTypeEnum.PlaceBet || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket)
               && ((isUserLoggedIn &&
               (accountBalance >= dialogModel.ticketData.totalStake && dialogModel.typeOfPlaceBetTicket === placeBetTypeEnum.Standard)
           || (freeBetBalance >= dialogModel.ticketData.totalStake  && dialogModel.typeOfPlaceBetTicket === placeBetTypeEnum.FreeBet)

               )
               || dialogModel.typeOfPlaceBetTicket == placeBetTypeEnum.Express)"
              (click)="placeBetWithTypeOfBetSelected()">
              <ng-container i18n=" Confirm Ticket confirm button@@ConfirmTicketConfirm">UPLATA</ng-container>
            </div>

            <div class="button place-bet" id="btnConfirmationTicket"
              *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.ConfirmationTicket"
              (click)="makeRequest(dialogModel.confirmationOrPlayedTicket)">
              <span i18n="ticket COnfirmation Ticket button@@ConfirmationTicket">PRIHVATI</span>
              <span *ngIf="timeToAccept > 0"> ({{timeToAccept}})</span>
            </div>
          </div>
        </ng-template>
      </ng-container>
      <div class="ticket-icon" (click)="closeDialog()">
        <div class="icon"></div>
        <span class="event-number">{{orderingForTicketItemGroups.length}}</span>
      </div>
    </div>


  </div>
</section>
